/**
 * ・定義ファイル名
 *   マスタメンテナンス画面定義ファイル
 * ・概要
 *   マスタメンテナンス画面（お知らせ情報マスタ）で使用する定義ファイル
 */

/* eslint-disable @typescript-eslint/camelcase */
/** 検索パネルのGrid1区間の横幅（%） */
export const SearchPanelColumnWidth = 10;

/** 検索画面の定義 */
export const InformationListDefine = {
  tableColumns: [
    { text: '詳細', value: 'detail', width: 100 },
    { text: '公開開始日', value: 'publication_start_date', width: 110 },
    { text: '公開終了日', value: 'publication_end_date', width: 110 },
    { text: '表題', value: 'information_title', width: 400 },
    { text: '登録日時', value: 'created_at', width: 180 },
    { text: '更新日時', value: 'updated_at', width: 180 }
  ],
  buttonItems: [
    {
      alwaysDisplayed: true,
      class: 'btn-normal',
      name: 'detail',
      text: '詳細',
      disabled: false
    }
  ],
  message: {
    dataTableText: '検索してください'
  }
};
/** ステータスが「削除済」のデータを検索から除外するための条件設定 */
export const InformationMasterDeleteStatusExcludeSearch = {
  id: 'Status', // Hexabase画面で入力したIDを指定
  search_value: ['information_deleted'], // 削除済ステータスのステータスID
  exact_match: true, // 完全一致で検索
  not_match: true // search_valueに指定した値でないItemを検索(NOT条件)
};
/** 検索時のソート（「公開開始日」の降順＞「作成日時」の降順） */
export const InformationDefaultSort = [
  {
    id: 'publication_start_date',
    order: 'desc'
  },
  {
    id: 'created_at',
    order: 'desc'
  }
];

/** 登録・詳細画面の定義 */
export const InformationDetailDefine = {
  regist: {
    registActionId: 'register'
  },
  edit: {
    initialActionId: 'update',
    updateActionId: 'information_valid_update',
    deleteActionId: 'information_valid_delete'
  }
};

/** 登録ガイドメッセージ */
export const authorityValidMessage = 'この内容でよろしければ「登録する」を押してください';
export const authorityInvalidMessage = '登録権限を持たないユーザです';
export const editAuthorityValidMessage = 'この内容でよろしければ「実行する」を押してください';

/** 登録・編集完了時の確認ダイアログ */
export const registerDialogTitle = '登録';
export const registerFinishText = '登録が完了いたしました';
export const registerFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'routing',
    name: 'toEdit',
    value: '詳細画面へ',
    route: '/information/edit/:id'
  }
];
export const editDialogTitle = '実行完了';
export const editFinishText = '※現在未使用';
export const editFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'reload',
    name: 'reload',
    value: '閉じる'
  }
];
